<template>
<div class="xaoi_img">
	<div class="conn" :style="{paddingTop:height}">
		<div class="pos">
			<img :src="src" :alt="alt">
		</div>
	</div>
</div>
</template>

<script>
export default {
	props:{
		alt:{
			default:''
		},
		src:{
			default:''
		},
		height:{
			default:'100%'
		},
	}
};
</script>

<style lang="scss" scoped>
.xaoi_img{
	width: 100%;font-size: 0;
	.conn{
		position:relative;z-index: 1;
	}
	.pos{
		width:100%;height: 100%;position:absolute;left:0;top:0;z-index: 2;
		text-align: center;
		&:after{content: '';display: inline-block;vertical-align: middle;height: 100%;width:0;}
		img{max-height: 100%;max-width: 100%;vertical-align: middle;}
	}
}
</style>